import { tenantApi } from '../../api/endpoints/tenant';
import { useAuth } from '../../hooks/useAuth';
import { useBrandingStore } from '../../stores/brandingStore';
import { resolvePlatformContainerTenantId } from '../../lib/brandingTenant';
import { BrandingEditorForm } from '../branding/BrandingEditorForm';

/**
 * Editor de branding del TENANT PROPIO (el del usuario logueado). Wrapper delgado sobre
 * `BrandingEditorForm`: resuelve el tenantId desde el user (platform admin '*' → ficha 'platform'),
 * inyecta tenantApi.getBranding/updateBranding y, vía `onSaved`, empuja el branding nuevo al
 * brandingStore global para que la app del usuario lo aplique al instante (sidebar/header/favicon).
 */
export function BrandingEditor() {
    const { user } = useAuth();
    // Platform admin (tenantId '*') edita el branding de la ficha [platform]; tenant normal pasa tal cual.
    const tid = resolvePlatformContainerTenantId(user?.tenantId) ?? '';
    const applyTenant = useBrandingStore((s) => s.applyTenantBranding);

    return (
        <BrandingEditorForm
            tenantId={tid}
            getBranding={tenantApi.getBranding}
            updateBranding={tenantApi.updateBranding}
            queryKeyPrefix={['branding']}
            onSaved={applyTenant}
        />
    );
}
